<script>
export let classes = 'my-12 flex h-12 w-12 mx-auto';
export let svgClasses = 'w-10 h-10';
</script>

<div class="{classes} text-black dark:text-gray-200">
  <span class="loader {svgClasses}"><span class="loader-inner"></span></span>
</div>